/**
 * The line under a track's name (SPEC-014 PR-14.6).
 *
 * One function rather than the same composition in the deck and in the shelf
 * row, because it encodes two decisions.
 *
 * THE STYLE LEADS, and it is on every row rather than only on the versions: what
 * a track sounds like is the useful thing to know about it, and a shelf where
 * only some rows carry a subtitle reads as a shelf with holes in it.
 *
 * WHAT FOLLOWS IT IS ONLY WHAT IS NEEDED. Most rows are their style and nothing
 * else. A recording the delivery NAMED adds that name — the Remix keeps the word
 * whoever made it used. And where two recordings of one title land on the same
 * style, the style has stopped telling them apart, so those two — and only those
 * two — add their measured tempo. A number is never printed bare: "136" under a
 * title reads as a rendering fault where "136 BPM" reads as a label, and the
 * sentence around it is chrome, so it comes from `t()` rather than from the
 * manifest.
 */
export default function trackSubtitle(track, t) {
    if (!track) {
        return null;
    }

    const parts = [track.style];

    if (track.variantKind === 'tempo') {
        parts.push(t('jukebox.versionTempo', { tempo: track.variant }));
    } else if (track.variantKind === 'length') {
        parts.push(t('jukebox.versionLength', { length: track.variant }));
    } else if (track.variant) {
        parts.push(track.variant);
    }

    return parts.filter(Boolean).join(' · ') || null;
}
